import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Form from './Form';

class Timesheets extends React.Component {
  render(): React.ReactElement {
    return (
      <Switch>
        <Route path="/timesheet-review/:id" component={Form} />
      </Switch>
    );
  }
}

export default Timesheets;
